// extracted by mini-css-extract-plugin
export default {"header":"RealPlayHeader_header__jyj98","right":"RealPlayHeader_right__NfOQA","scenarioSelector":"RealPlayHeader_scenarioSelector__5DF6Z"};